<template>
  <div
    class="list-item-presenter"
    :class="{ 'list-item-presenter--bordered': !isNested }"
  >
    <div class="question" :class="{ 'is-nested': isNested }">
      <slot name="header" />
      <div
        class="question__body"
        :class="{ 'question__body--nested': isNested }"
      >
        <transition :name="transitionEnabled ? 'appear' : ''">
          <div
            v-if="!!$slots.content"
            class="question__content"
            :class="{ 'question__content--highlighted': isOwner }"
          >
            <slot name="content" />
          </div>
        </transition>

        <div class="question__actions">
          <slot name="editActions" />
        </div>

        <ListItemNestedContainer
          v-if="totalCount > 0"
          :items-quantity="totalCount"
          @toggle-answers="$emit('toggle-answers', $event)"
        >
          <transition-group name="list" tag="div" class="question__items">
            <div v-for="item in items" :key="item.id">
              <slot name="nestedItems" :item="item" />
            </div>
          </transition-group>
        </ListItemNestedContainer>
        <slot name="loader" />
        <div v-if="!!$slots.publishActions">
          <slot name="publishActions" />
        </div>
      </div>
    </div>
    <div v-if="!isNested" class="company-card">
      <slot name="companyCard" />
    </div>
  </div>
</template>

<script>
import ListItemNestedContainer from "@/components/QuestionsAndAnswers/QaListItemNestedContainer.vue";

export default {
  name: "QaListItemPresenter",
  components: {
    ListItemNestedContainer
  },
  props: {
    isOwner: {
      type: Boolean,
      default: false
    },
    items: {
      type: [Array, null]
    },
    transitionEnabled: {
      type: Boolean,
      default: false
    },
    totalCount: {
      type: Number,
      default: 0
    },
    isNested: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.list-item-presenter {
  display: flex;
  padding: $spacing * 2 0;

  &--bordered {
    border-bottom: 1px solid $gray-200;
  }
}

.company-card {
  max-width: 582px;
  width: 100%;
}

.question {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-width: 480px;
  width: 100%;

  &.is-nested {
    min-width: 440px;
  }

  &:not(.is-nested) {
    padding-right: $spacing * 4;
    margin-right: $spacing * 4;
    border-right: 1px solid $gray-200;
  }

  &__publish-actions {
    width: calc(100% - 70px);
    margin-left: auto;
    display: flex;
  }

  &__actions {
    margin-top: $spacing * 2;
  }

  &__items {
    display: flex;
    flex-direction: column;
    gap: $spacing * 2;
  }

  &__body {
    &--nested {
      padding-left: $spacing * 8.75;
      position: relative;

      &:before {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 1px;
        height: calc(100% - 16px);
        background-color: $gray-200;
        margin-left: $spacing * 2.875;
      }
    }
  }

  &__content {
    @include font-size(14px);
    margin-top: $spacing * 2;
    background-color: $light-4;
    padding: $spacing * 2 $spacing * 4;
    border-radius: 20px;
    font-weight: 400;

    &--highlighted {
      background: lighten($gray-700, 3%);
    }
  }
}

.list-enter-active,
.list-leave-active {
  opacity: 1;
  transition: opacity 0.75s;
}
.list-enter,
.list-leave-to {
  opacity: 0;
  transition: opacity 0.4s;
}

.appear-enter-active {
  transition: opacity 0.5s, background-color 0.6s 0.2s;
  background-color: lighten($gray-700, 3%);
}
.appear-enter {
  opacity: 0;
  background-color: darken($gray-700, 5%);
}
</style>
